import React from 'react';

interface ContactUsFields {
    className?: string;
    contentType?: string;
    description?: string;
    name?: string;
    title?: string;
    anchorId?: string;
}

interface ArticleContactUsProps {
    contactUsContent?: {
        fields?: ContactUsFields;
    };
}

const ArticleContactUs: React.FC<ArticleContactUsProps> = ({ contactUsContent }) => {
    return (
        <div id={contactUsContent?.fields?.anchorId} className='px-2 md:px-0'>
            <p className='font-semi-bold text-lg lg:text-25 text-revamp_blueText leading-tight py-2 lg:pt-2h mx-2 mt-8 mb-2 border-revamp_borderBlue'>
                {contactUsContent?.fields?.title && (
                    <span>{contactUsContent.fields.title}</span>
                )}
            </p>
            <p className='text-base lg:text-lg text-revamp_grey_text mx-2 mb-8'>
                {contactUsContent?.fields?.description}
            </p>
        </div>
    );
};

export default ArticleContactUs;